import styled from 'styled-components';

import { Button } from '@pearsontechnology/aero-components';

const infoIcon = 'data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMjE5NmYzIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4gIDxwYXRoIGQ9Ik0xMiAyQzYuNDggMiAyIDYuNDggMiAxMnM0LjQ4IDEwIDEwIDEwIDEwLTQuNDggMTAtMTBTMTcuNTIgMiAxMiAyem0xIDE1aC0ydi02aDJ2NnptMC04aC0yVjdoMnYyeiIvPjwvc3ZnPg==';

export const Wrapper = styled.div`
  padding: 30px 20px;
`;

export const Title = styled.div`
  color: ${(props) => props.theme['color.text.body']};
  font-size: 22px;
  line-height: 30px;
`;

export const ThumbnailGrid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 22px;
`;

export const ThumbnailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-start;

  height: 143px;
  width: 171px;
  margin-bottom: 15px;
  border-radius: 4px;
  pointer-events: auto;
  background-color: ${(props) => props.theme['color.surface']};
  box-shadow: ${(props) => props.theme['shadow.card']};
  cursor: pointer;
  transition: box-shadow 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 14px 0 rgba(0,0,0,0.12), 0 2px 6px 0 rgba(0,0,0,0.2), 0 8px 20px 0 rgba(0,0,0,0.04);
  }
`;

export const Placeholder = styled.div`
  height: 91px;
  border-radius: 4px 4px 0 0;
`;

export const ThumbnailTitleWrapper = styled.div`
  display:flex;
  justify-content: center;
  align-items: center;
  margin: 10px 18px;
  max-height: 42px;
`;

export const ThumbnailTitle = styled.div`
  color: ${(props) => props.theme['color.text.body']};
  font-size: 14px;
  line-height: 19px;
  text-align: center;

  & > p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const ThumbnailBoxBorder = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 91px;
  border-radius: 4px 4px 0 0;
`;

export const ThumbnailBox = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  ${(props) => props.thumbnailUrl && `
       background: url(${props.thumbnailUrl});
       background-size: cover;
  `}
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
`;

export const ViewMore = styled.a`
  display: inline;
  cursor: pointer;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  line-height: 17px;
  letter-spacing: 1px;
  color: ${(props) => props.theme['color.input.foreground']};

  & > i {
    color: ${(props) => props.theme['color.text.light']};
    opacity: 0.7;
    font-size: 20px;
    vertical-align: middle;
    transform: translate3d(0, -0.05em, 0);
    margin: -5px 0 0 2px;
  }
`;

export const Article = styled.span`
  color: ${(props) => props.theme['color.blueDark']};
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 17px;
`;

export const Back = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${(props) => props.theme['color.blueDark']};
  padding: 20px 15px 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 12px;
  font-weight: bold;

  & > i {
      font-size: 30px;
    }
`;

export const Divider = styled.div`
  height: 1px;
  border-bottom: 1px solid ${(props) => props.theme['color.greyDark']};
  margin-left: 20px;
  opacity: 0.6;
`;

export const SearchWrapper = styled.div`
  position: relative;
  margin-top: 20px;
`;

export const CloseButton = styled(Button)`
  position: absolute;
  right: 0;
  top: 0;
`;

export const ArticleViewWrapper = styled.div`
  padding: 20px;
`;

export const ArticleLink = styled.a`
  color: ${(props) => props.theme['color.input.foreground']};
  cursor: pointer;
  outline: none;
  text-decoration: none;
  font-size: 24px;
  font-weight: 600;

  & > i {
    color: ${(props) => props.theme['color.text.light']};
    opacity: 0.7;
    font-size: 20px;
    vertical-align: middle;
    padding-left: 5px;
    padding-bottom: 3px;
  }
`;

export const ArticleDescription = styled.div`
  color: ${(props) => props.theme['color.input.foreground']};
  font-size: 15px;
`;

export const ArticleContent = styled.div`
  overflow-y: auto;
  color: ${(props) => props.theme['color.input.foreground']};
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;

  img {
    display: block;
    margin: 0 auto;
    max-width: 98%;
    height: 100%;
    box-shadow: ${(props) => props.theme['shadow.card']};
  }

  H1 {
    font-size: 24px;
    font-weight: 600;
    line-height: 1.2em;
  }

  H2 {
    font-size: 18px;
    font-weight: 600;
    line-height: 1.2em;
  }

  H3 {
    font-size: 18px;
    font-weight: 400;
    line-height: 1.2em;
  }

  ul > li, ol > li {
    padding: 5px 0;

    img {
      margin: 10px auto;
    }
  }

  a {
    color: ${(props) => props.theme['color.blueDark']};
    text-decoration: none;
  }

  blockquote {
    background: rgba(33, 150, 243, 0.2);
    border-left: 5px solid #2196f3;
    border-radius: 4px;
    padding: 20px;
    margin: 30px 0;
    display: flex;

    &:before {
      content: '';
      width: 24px;
      height: 24px;
      margin-right: 20px;
      position: relative;
      top: 2px;
      flex: 0 0 auto;
      background-repeat: no-repeat;
      background-image: url(${infoIcon});
    }

    p {
      margin: 0;
    }
  }
`;
